export default __webpack_public_path__ + "static/media/809.47e4ef6b.png";